const config = {
  api: process.env.REACT_APP_API_URL,
  classfy_api: process.env.REACT_APP_CLASSFY_API_URL,
  classfy_token: process.env.REACT_APP_CLASSFY_TOKEN
}

export default config
